import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';
import { CommonModule, AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterModule, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { ReportService } from '../../components/report-filters/services/report.service';
import {
  QaEvaluatorReviewsReportTableComponentModule,
  QaEvaluatorReviewsReportTableComponent
} from './components/qa-evaluator-reviews-report-table/qa-evaluator-reviews-report-table.component';
import { QaEvaluatorReviewsSectionComponent } from './components/qa-evaluator-reviews-section/qa-evaluator-reviews-section.component';
import { QaEvaluatorReviewType, QaEvaluatorReviewTypes } from './qa-evaluator-reviews-report.model';
import { QaEvaluatorReviewsReportService } from './qa-evaluator-reviews-report.service';
import { PermissionEnum } from '@core/permissions/permission.enum';
import { getStaticFileUrl } from '@utils/media.utils';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { GenericPageComponent } from '@shared/modules/general-commons/components/generic-page/generic-page.component';
import { PermittedDirective } from '@core/permissions/permitted.directive';
import { RoleEnum } from '@src/app/features/authentication/helpers/role.enum';
import { AuthService } from '@src/app/features/authentication/services/auth.service';

@Component({
  selector: 'stx-qa-evaluator-reviews-report',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './qa-evaluator-reviews-report.component.html',
  styleUrls: ['./qa-evaluator-reviews-report.component.scss'],
  imports: [
    GenericPageComponent,
    RouterLink,
    PermittedDirective,
    QaEvaluatorReviewsSectionComponent,
    QaEvaluatorReviewsReportTableComponent,
    MatIcon,
    TranslateModule,
    AsyncPipe
  ]
})
export class QaEvaluatorReviewsReportComponent extends BaseComponent implements OnInit {
  qaEvaluatorReviewsReportService = inject(QaEvaluatorReviewsReportService);
  reportService = inject(ReportService);
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);

  readonly PermissionEnum = PermissionEnum;
  readonly QaReviewsReportRange = QaReviewsReportRange;
  reviewType: QaEvaluatorReviewType;
  QaEvaluatorReviewTypes = QaEvaluatorReviewTypes;

  constructor() {
    super();
    this.watchRouteParams();
  }

  ngOnInit(): void {
    this.subSink.sink = this.route.queryParams.subscribe(params => {
      let range = QaReviewsReportRange.LAST_TWO_YEARS;
      if (!!params.range) {
        range = params.range;
      }
      this.qaEvaluatorReviewsReportService.prepareLists(range);
    });
  }

  watchRouteParams() {
    this.subSink.sink = this.route.data.subscribe(data => {
      this.reviewType = data.qaReportType;
    });
  }

  get oldStatsUrl(): string {
    return getStaticFileUrl('pdf/QA_surgical_reviewer_period_count-OLD.csv');
  }

  trialMessageForSTProgram(): boolean {
    return this.authService.checkUserRole(RoleEnum.ST_PROGRAM);
  }
}

@NgModule({
  imports: [
    TranslateModule,
    CommonModule,
    QaEvaluatorReviewsReportTableComponentModule,
    GeneralCommonsModule,
    RouterModule,
    MatIconModule,
    QaEvaluatorReviewsReportComponent
  ],
  exports: [QaEvaluatorReviewsReportComponent]
})
export class QaEvaluatorReviewsReportComponentModule {}

export enum QaReviewsReportRange {
  LAST_YEAR = 'LAST_YEAR',
  LAST_TWO_YEARS = 'LAST_TWO_YEARS',
  ALL = 'ALL'
}
